import { Component } from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import Cookies from 'js-cookie';

import MainBanner from '../banners/MainBanner';
import Features from './Features';
import s from './styles.scss';
import Content from './Content';

class MainPage extends Component {
  state = {
    visible: false,
  };

  handleVisible = () => {
    if (
      window &&
      typeof window === 'object' &&
      window.scrollTo &&
      typeof window.scrollTo === 'function'
    ) {
      window.scrollTo(0, 0);
    }

    this.setState({
      visible: true,
    });
  };

  render() {
    const { visible } = this.state;
    const { data } = this.props;
    const nextPage = '/plans';
    let initialDimensions = { height: 0, width: 0 };

    if (typeof window !== 'undefined' && window) {
      initialDimensions = {
        height: window.innerHeight,
        width: window.innerWidth,
      };
    }

    return (
      <div className={s.main}>
        <Head>
          {data.page_title && <title>{data.page_title}</title>}
          {data.meta_description && (
            <meta name="description" content={data.meta_description} />
          )}
        </Head>
        <MainBanner
          {...data}
          initialDimensions={initialDimensions}
          nextPage={nextPage}
          visibleFromProps={visible}
        />
        <Features {...data} />
        <Content
          {...data}
          link="/entities"
          handleVisible={() => this.handleVisible()}
        />
      </div>
    );
  }
}

MainPage.propTypes = {
  data: PropTypes.object,
};

export default MainPage;
